/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Notificationpreferences_Noteditable2Inputs */

const en_settings_notificationpreferences_noteditable2 = /** @type {(inputs: Settings_Notificationpreferences_Noteditable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This setting is not editable`)
};

/**
* | output |
* | --- |
* | "This setting is not editable" |
*
* @param {Settings_Notificationpreferences_Noteditable2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_notificationpreferences_noteditable2 = /** @type {((inputs?: Settings_Notificationpreferences_Noteditable2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Notificationpreferences_Noteditable2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_notificationpreferences_noteditable2(inputs)
});
export { settings_notificationpreferences_noteditable2 as "settings_notificationPreferences_notEditable" }